import useSWR from "swr";

const fetchConfig = async () => {
    const rsp = await fetch("/api/config");
    return rsp.json();
    }

const useConfig = () => useSWR("/api/config", fetchConfig);

export default useConfig;